/** Time-of-day greeting, so the page does not open with the same line all day. */
export function greetingFor(date: Date): string {
  const hour = date.getHours()
  if (hour < 11) return "Guten Morgen"
  if (hour < 18) return "Guten Tag"
  return "Guten Abend"
}
